import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { agregarLogosPdf } from '../../utils/exportUtils.js';

/**
 * Exportación de los resultados del Asistente IA -- puerto de
 * `IbuFront/src/components/ia/exportResultado.js` (V1: jsPDF + js-export-excel).
 * V2 usa `xlsx` y `jspdf-autotable` modular (mismo criterio que `utils/exportUtils.js`).
 */
function columnasDe(rows) {
  if (!rows?.length) return [];
  return Object.keys(rows[0]);
}

export function exportarExcel(rows, nombre = 'asistente_ia') {
  const columnas = columnasDe(rows);
  if (!columnas.length) return;
  const hoja = XLSX.utils.json_to_sheet(rows, { header: columnas });
  const libro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(libro, hoja, nombre.slice(0, 31));
  XLSX.writeFile(libro, `${nombre}.xlsx`);
}

export async function exportarPdf(rows, nombre = 'asistente_ia', titulo = 'Datos del asistente IA') {
  const columnas = columnasDe(rows);
  if (!columnas.length) return;
  const orientation = columnas.length > 6 ? 'landscape' : 'portrait';
  const doc = new jsPDF({ orientation });
  // Decisión del usuario: todos los PDF llevan los logos (V1 no los ponía aquí).
  await agregarLogosPdf(doc, { orientation });
  doc.setFontSize(14);
  doc.text(titulo, 14, 25);
  autoTable(doc, {
    head: [columnas],
    body: rows.map((r) => columnas.map((c) => (r[c] == null ? '' : String(r[c])))),
    startY: orientation === 'landscape' ? 45 : 52, // debajo de los logos
    styles: { fontSize: 8 },
  });
  doc.save(`${nombre}.pdf`);
}
